import { Col, Row } from 'antd';
import 'react-phone-input-2/lib/style.css';
import { useWindowSize } from 'react-use';
import { isMobileBrowser } from '../../common/utils';
import '../auth/auth.less';
import AuthSlider from './AuthSlider';
import LoginForm from './LoginForm';

const Login = () => {
  const { width } = useWindowSize();
  return (
    <div className="login-container">
      <Row>
        {!isMobileBrowser(width) && (
          <Col
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            sm={24}
            xs={24}
            className="slider"
          >
            <AuthSlider />
          </Col>
        )}
        <LoginForm />
      </Row>
    </div>
  );
};

export default Login;
